import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const APPLICATION_DELETE_RESOURCE = "application" as const;
export const APPLICATION_DELETE_API_PATH = `/v1/${APPLICATION_DELETE_RESOURCE}/{uuid}` as const;

export type ApplicationDeleteResponse =
  paths[typeof APPLICATION_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useApplicationDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApplicationDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<ApplicationDeleteResponse>(
        `/v1/${APPLICATION_DELETE_RESOURCE}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [APPLICATION_DELETE_RESOURCE],
      });
    },
  });
};
